import React, { Fragment } from "react";
import { Field } from "formik";
import { Input, Row, Col } from "antd";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";

export default ({ disabled, rowData }) => {
  const [center, setCenter] = React.useState({
    lat: parseFloat(rowData.latitude != null ? rowData.latitude : "33.6617"),
    lng: parseFloat(rowData.longitude != null ? rowData.longitude : "73.0568"),
  });
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const containerStyle = {
    width: "100%",
    height: "400px",
  };
  return (
    <Fragment>
      <Row>
        <Col span={12}>
          <Row>
            <Col span={24} className="column-text-field">
              <Field
                InputType={Input}
                component={FormInputField}
                name="longitude"
                labelText="Longitude"
                hideErrorMessage={true}
                className="text-field"
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24} className="column-text-field">
              <Field
                InputType={Input}
                component={FormInputField}
                name="latitude"
                labelText="Latitude"
                hideErrorMessage={true}
                className="text-field"
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24} className="column-text-field">
              <Field
                InputType={Input}
                component={FormInputField}
                name="address"
                labelText="Address"
                hideErrorMessage={true}
                className="text-field"
                disabled={disabled}
              />
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={17}
            >
              <Marker key={1} position={center} />
            </GoogleMap>
          </LoadScript>
        </Col>
      </Row>
    </Fragment>
  );
};
